import axios from 'axios'
import Helpers from './helpers'

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return {void}
 */
const loginActions = ({ commit }, response) => {
    let user = Helpers.getUser(response)
    let userToken = Helpers.getAccessToken_FromLoginResponse(response)

    localStorage.setItem('user', user)
    commit('SET_USER', user)
    localStorage.setItem('user-token', userToken)
    commit('SET_TOKEN', userToken)
    if (response.data.g_user_ground_seller) {
        localStorage.setItem(
            'ground_seller',
            JSON.stringify(response.data.g_user_ground_seller)
        )
        commit('SET_GROUND_SELLER', response.data.g_user_ground_seller)
    }
    localStorage.setItem(
        'pos_workstation_type',
        JSON.stringify(response.data.pos_workstation_type)
    )
    commit('SET_POS_WORKSTATION_TYPE', response.data.pos_workstation_type)
    // Here set the header of your ajax library to the token value.
    axios.defaults.headers.common['Authorization'] = userToken
}

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return {void}
 */
const logoutActions = ({ commit }) => {
    commit('authLogout')
    localStorage.removeItem('user')
    localStorage.removeItem('user-token')
    delete axios.defaults.headers.common['Authorization']
}

const authorizeSeller = (
    {},
    { code, permission = 'access_to%20point_sale' }
) => {
    code = ('' + code).padStart(3, '0')
    code = parseInt(code)
    let route =
        process.env.VUE_APP_API_ROUTE +
        '/authorization?auth_code=' +
        code +
        `&permission=${permission}`
    return new Promise((resolve, reject) => {
        axios
            .get(route)
            .then(response => {
                if (response.data.is_authorized) {
                    resolve(response.data)
                } else {
                    reject('Código incorrecto o usuario no autorizado')
                }
            })
            .catch(() => {
                reject('Código incorrecto o error Autorización')
            })
    })
}

const authorizeSupervisor = (
    {},
    { code, permission = '&permission=authorize%20ticket%20sale' }
) => {
    let route =
        process.env.VUE_APP_API_ROUTE +
        '/bar_authorization?auth_code=' +
        code +
        permission
    return new Promise((resolve, reject) =>
        axios
            .get(route)
            .then(response => {
                if (response.data.is_authorized) {
                    resolve(response.data)
                } else {
                    reject('No Autorizado')
                }
            })
            .catch(() => {
                reject('Error Autorización')
            })
    )
}

export default {
    loginActions,
    logoutActions,
    authorizeSeller,
    authorizeSupervisor,
}
